export default {
  login: {
    welcome: 'Bem-vindo de volta',
    subtitle: 'Faça login para continuar comprando',
    phonePlaceholder: 'Digite o número de telefone',
    passwordPlaceholder: 'Digite a senha',
    showPassword: 'Mostrar',
    hidePassword: 'Ocultar',
    loginButton: 'Entrar',
    registerButton: 'Registro gratuito',
    title: 'Entrar',
    subtitle2: 'Compras globais tudo em um para ganhar recompensas',
    logging: 'Entrando...',
    phoneRequired: 'Digite o número de telefone',
    passwordRequired: 'Digite a senha',
    loginSuccess: 'Login bem-sucedido',
    loginFailed: 'Falha no login',
    loginError: 'Erro de login, tente novamente mais tarde'
  },
  register: {
    title: 'Criar conta',
    subtitle: 'Junte-se a nós e comece sua jornada de negociação',
    username: 'Nome de usuário',
    phone: 'Número de telefone',
    loginPassword: 'Senha de login',
    transactionPassword: 'Senha de transação',
    invitationCode: 'Código de convite',
    usernamePlaceholder: 'Digite o nome de usuário',
    phonePlaceholder: 'Digite o número de telefone',
    loginPasswordPlaceholder: 'Digite a senha de login',
    transactionPasswordPlaceholder: 'Digite a senha de transação',
    invitationCodePlaceholder: 'Digite o código de convite',
    registerButton: 'Registrar',
    hasAccount: 'Já tem conta? Entrar',
    errorUsername: 'Digite o nome de usuário',
    errorPhone: 'Digite o número de telefone',
    errorLoginPassword: 'Digite a senha de login',
    errorTransactionPassword: 'Digite a senha de transação',
    errorInviteCode: 'Digite o código de convite',
    registerSuccess: 'Registro bem-sucedido'
  },
  tabbar: {
    home: 'Início',
    purchase: 'Histórico de pedidos',
    grabbing: 'Pedir',
    kefu: 'Atendimento ao cliente',
    my: 'Meu'
  },
  home: {
    orderCount: 'Número de pedidos',
    upgradeAmount: 'Recarregar e atualizar',
    recharge: 'Recarregar',
    withdraw: 'Sacar',
    team: 'Gerenciamento de equipe',
    commission: 'Obter comissão',
    newProducts: 'Novos produtos',
    newProductsDesc: 'Os últimos estilos da nova temporada e coleções futuras.',
    buyNow: 'Comprar agora',
    nowAvailable: 'Disponível agora',
    nowAvailableDesc: 'Prepare-se para a temporada de casamentos, arrume para sua próxima viagem e atualize seu guarda-roupa sem compromisso. Com nosso novo plano de empréstimo, você pode experimentar as últimas tendências e manter-se dentro do seu orçamento sem assinatura.',
    footerTitle: 'Desigual.com',
    footerFollow: "Siga-nos em {'@'}Desigual.com e compartilhe seus estilos favoritos de Desigual.com!",
    footerShop: 'Navegue nosso catálogo'
  },
  purchase: {
    all: 'Todos',
    pending: 'Pendente',
    completed: 'Concluído',
    frozen: 'Congelado',
    balance: 'Saldo da conta',
    orderTime: 'Hora do pedido',
    orderId: 'Número do pedido',
    totalAmount: 'Total do pedido',
    commission: 'Comissão',
    expectedReturn: 'Retorno esperado',
    submitOrder: 'Enviar pedido',
    orderCompleted: 'Pedido concluído',
    loading: 'Carregando...',
    noData: 'Sem dados de pedidos',
    noMore: 'Não há mais',
    orderSuccess: 'Pedido bem-sucedido',
    orderNumber: 'Número do pedido',
    rating: 'Avaliação',
    notSubmit: 'Não enviar por enquanto',
    submitNow: 'Enviar agora',
    submitting: 'Enviando...',
    submitFailed: 'Falha ao enviar',
    grabOrderFailed: 'Falha ao pegar pedido, tente novamente mais tarde',
    getOrderInfoFailed: 'Falha ao obter detalhes do pedido',
    submitOrderFailed: 'Falha ao enviar, tente novamente mais tarde'
  },
  common: {
    home: 'Início',
    about: 'Sobre',
    contact: 'Contate-nos',
    purchase: 'Histórico de pedidos',
    grabbing: 'Pedir',
    my: 'Meu',
    login: 'Entrar',
    register: 'Registrar',
    kefu: 'Atendimento ao cliente',
    loadDataError: 'Falha ao carregar dados, tente novamente mais tarde',
    success: 'Operação bem-sucedida',
    failed: 'Operação falhou',
    submitSuccess: 'Envio bem-sucedido',
    submitFailed: 'Falha ao enviar',
    submitting: 'Enviando...'
  },
  grabbing: {
    accountAmount: 'Valor da conta',
    accountBalance: 'Saldo da conta',
    getCommission: 'Obter comissão',
    ordersGrabbedToday: 'Pedidos pegos hoje',
    orderCount: 'Número de pedidos',
    operationSteps: 'Etapas de operação',
    step1: '1. Clique no botão Iniciar tarefa e complete a tarefa de acordo com as instruções',
    step2: '2. Após completar a tarefa, você pode liquidar a comissão para o saldo',
    grabOrder: 'Pegar pedido',
    pleaseWait: 'Por favor aguarde',
    grabSuccess: 'Pedido bem-sucedido',
    grabTime: 'Hora do pedido',
    grabNumber: 'Número do pedido',
    orderTotal: 'Total do pedido',
    commission: 'Comissão',
    expectedReturn: 'Retorno esperado',
    rating: 'Avaliação',
    notSubmit: 'Não enviar por enquanto',
    submitNow: 'Enviar agora',
    submitting: 'Enviando...'
  },
  kefu: {
    title: 'Atendimento ao cliente',
    intro: {
      line1: 'Se você tiver alguma dúvida ou precisar de ajuda,',
      line2: 'entre em contato com o atendimento ao cliente para resolvê-la'
    },
    serviceTime: {
      label: 'Horário de atendimento',
      text: 'Seu atendimento ao cliente exclusivo',
      online: 'Online'
    },
    contact: {
      title: 'Contato',
      name: 'Online',
      status: 'Consultar',
      feature1: 'Resposta imediata',
      feature2: 'Serviço profissional',
      button: 'Contatar'
    },
    faq: {
      title: 'Perguntas frequentes',
      rechargeQuestion: 'Como recarregar?',
      rechargeAnswer: 'Você pode recarregar através do nosso gateway de pagamento seguro. Vá para Minha conta > Recarregar e siga as instruções.',
      withdrawQuestion: 'Como sacar?',
      withdrawAnswer: 'Saques podem ser feitos através de Minha conta > Sacar. Certifique-se de que sua conta esteja verificada.',
      minRechargeQuestion: 'Qual é o valor mínimo de recarga?',
      minRechargeAnswer: 'O valor mínimo de recarga é ${currency}68.',
      withdrawTimeQuestion: 'Quanto tempo demora um saque?',
      withdrawTimeAnswer: 'Saques geralmente são processados dentro de 24 horas.',
      securityQuestion: 'Minha informação é segura?',
      securityAnswer: 'Sim, usamos tecnologia de criptografia padrão da indústria para proteger suas informações pessoais e financeiras.'
    }
  },
  my: {
    inviteCode: 'Código de convite',
    copy: 'Copiar',
    copySuccess: 'Copia bem-sucedida',
    copyFailed: 'Falha ao copiar',
    online: 'Online',
    accountAmount: 'Valor da conta',
    balance: 'Saldo da conta',
    accountBalanceTrend: 'Saldo da conta',
    todayCommission: 'Comissão de hoje',
    totalCommission: 'Comissão total',
    today: 'Hoje',
    total: 'Total',
    todayOrders: 'Pedidos pegos hoje',
    orderCount: 'Número de pedidos',
    recharge: 'Recarregar',
    withdraw: 'Sacar',
    rechargeRecord: 'Histórico de recargas',
    withdrawRecord: 'Histórico de saques',
    accountDetails: 'Detalhes da conta',
    receivingAccount: 'Conta de recebimento',
    bankAccount: 'Conta bancária',
    bankAccountDesc: 'Conta bancária',
    usdt: 'USDT',
    usdtDesc: 'Endereço USDT',
    connect: 'Conectar',
    teamManagement: 'Gerenciamento de equipe',
    viewTeam: 'Ver equipe',
    changePassword: 'Alterar senha',
    changeWithdrawPassword: 'Alterar senha de saque',
    passwordSettings: 'Configurações de senha',
    logout: 'Sair',
    signOut: 'Sair',
    version: 'Versão'
  },
  changePasswordPage: {
    currentPassword: 'Senha de login atual',
    currentPasswordPlaceholder: 'Digite a senha atual',
    newPassword: 'Nova senha de login',
    newPasswordPlaceholder: 'Digite a nova senha',
    confirmPassword: 'Confirmar senha de login',
    confirmPasswordPlaceholder: 'Confirme a nova senha',
    notice: 'A senha de login é usada para acessar a conta. A senha deve ter pelo menos 6 caracteres e conter letras e números para garantir a segurança.',
    updateButton: 'Atualizar senha de login',
    errorOldPassword: 'Digite a senha atual',
    errorNewPassword: 'Digite a nova senha',
    errorConfirmPassword: 'Confirme a nova senha',
    errorPasswordMismatch: 'As senhas não coincidem',
    errorPasswordLength: 'A senha deve ter pelo menos 6 caracteres',
    errorPasswordFormat: 'A senha deve conter letras e números'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Senha de saque atual',
    currentPasswordPlaceholder: 'Digite a senha de saque atual',
    newPassword: 'Nova senha de saque',
    newPasswordPlaceholder: 'Digite a nova senha de saque',
    confirmPassword: 'Confirmar senha de saque',
    confirmPasswordPlaceholder: 'Confirme a nova senha de saque',
    notice: 'A senha de saque é usada para operações de saque de fundos. A senha deve ter pelo menos 6 caracteres e conter letras e números para garantir a segurança.',
    updateButton: 'Atualizar senha de saque',
    errorOldPassword: 'Digite a senha de saque atual',
    errorNewPassword: 'Digite a nova senha de saque',
    errorConfirmPassword: 'Confirme a nova senha de saque',
    errorPasswordMismatch: 'As senhas não coincidem',
    errorPasswordLength: 'A senha deve ter pelo menos 6 caracteres',
    errorPasswordFormat: 'A senha deve conter letras e números'
  },
  details: {
    loading: 'Carregando...',
    noRecords: 'Sem registros',
    noMore: 'Não há mais',
    time: 'Hora',
    type: 'Tipo',
    amount: 'Valor',
    balance: 'Saldo',
    remark: 'Observação',
    type0: 'Outro',
    type1: 'Recarga',
    type2: 'Saque',
    type3: 'Transação',
    type4: 'Comissão de pedido',
    type5: 'Comissão de subordinado',
    type8: 'Saque rejeitado'
  },
  rechargeRecord: {
    offline: 'Recarga offline',
    online: 'Recarga online',
    loading: 'Carregando...',
    noRecords: 'Sem registros',
    orderNo: 'Número do pedido',
    rechargeAmount: 'Valor de recarga',
    rechargeTime: 'Hora de recarga',
    payMethod: 'Método de pagamento',
    rechargeStatus: 'Status de recarga',
    noMore: 'Não há mais',
    statusPending: 'Pendente de aprovação',
    statusApproved: 'Aprovado',
    statusFailed: 'Falha',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Carregando...',
    noRecords: 'Sem registros',
    orderNo: 'Número do pedido',
    withdrawAmount: 'Valor de saque',
    withdrawTime: 'Hora de saque',
    withdrawAddress: 'Endereço de saque',
    withdrawStatus: 'Status de saque',
    noMore: 'Não há mais',
    statusPending: 'Processando',
    statusApproved: 'Bem-sucedido',
    statusFailed: 'Falha',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Sacar',
    method: 'Método de saque',
    methodSubtitle: 'Selecione seu método de saque',
    bankInfo: 'Informações da conta bancária',
    bankName: 'Banco',
    accountHolder: 'Nome do titular',
    bankCard: 'Cartão bancário',
    amount: 'Valor de saque',
    balance: 'Saldo',
    withdrawAll: 'Sacar tudo',
    paymentPassword: 'Senha de pagamento',
    passwordPlaceholder: 'Digite a senha de fundos',
    principal: 'Valor principal',
    serviceFee: 'Taxa de serviço',
    netAmount: 'Valor líquido',
    notice: '*Verifique cuidadosamente as informações de recebimento',
    withdrawButton: 'Sacar',
    walletAddress: 'Endereço da carteira',
    walletAddressSubtitle: 'Digite o endereço da carteira'
  },
  recharge: {
    title: 'Recarregar',
    amount: 'Valor de recarga',
    amountSubtitle: 'Digite o valor que deseja recarregar',
    quickSelect: 'Seleção rápida',
    rechargeNow: 'Recarregar agora',
    selectPayment: 'Selecionar método de pagamento',
    selectPaymentSubtitle: 'Selecione seu método de pagamento preferido',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    crypto: 'Criptomoeda',
    bank: 'Transferência bancária',
    paymentRange: 'Mínimo: {symbol}{minAmount} - Máximo: {symbol}{maxAmount}',
    rechargeFailed: 'Falha ao recarregar',
    paymentInfo: 'Informações de pagamento',
    usercode: 'Endereço USDT',
    uploadScreenshot: 'Por favor, envie a captura de tela do pagamento',
    clickToUpload: 'Clique para enviar captura de tela',
    copySuccess: 'Copiado com sucesso',
    copyFailed: 'Falha ao copiar',
    uploadScreenshotRequired: 'Por favor, envie a captura de tela do pagamento',
    submit: 'Enviar',
    submitting: 'Enviando...',
    submitSuccess: 'Enviado com sucesso',
    submitFailed: 'Falha ao enviar'
  },
  bindUsdt: {
    title: 'Vincular USDT',
    cardTitle: 'Endereço USDT',
    cardSubtitle: 'Digite seu endereço de carteira USDT',
    walletAddress: 'Endereço da carteira',
    walletAddressPlaceholder: 'Digite o endereço da carteira USDT',
    networkType: 'Tipo de rede',
    networkTypePlaceholder: 'Selecione o tipo de rede',
    withdrawPassword: 'Senha de saque',
    withdrawPasswordPlaceholder: 'Digite a senha de saque',
    trc20: 'TRC20',
    trc20Network: 'Rede TRC20',
    erc20: 'ERC20',
    erc20Network: 'Rede ERC20',
    securityNotice: 'Aviso de segurança',
    securityText1: '• Seu endereço USDT está criptografado e armazenado com segurança',
    securityText2: '• Apenas você pode visualizar e modificar esta informação',
    securityText3: '• Certifique-se de que todas as informações estejam corretas',
    buttonText: 'Salvar informações',
    buttonSubtitle: 'Vincular endereço USDT',
    errorWalletAddress: 'Digite o endereço da carteira',
    errorNetworkType: 'Selecione o tipo de rede',
    errorWithdrawPassword: 'Digite a senha de saque'
  },
  team: {
    title: 'Gerenciamento de equipe',
    level1: 'Equipe de nível 1',
    level2: 'Equipe de nível 2',
    level3: 'Equipe de nível 3',
    level1Members: 'Membros da equipe de nível 1',
    level2Members: 'Membros da equipe de nível 2',
    level3Members: 'Membros da equipe de nível 3',
    totalMembers: 'Total de membros',
    totalCommission: 'Comissão total',
    members: 'pessoas',
    orders: 'Pedidos',
    commission: 'Comissão',
    noMembers: 'Sem membros',
    loading: 'Carregando...',
    noMore: 'Não há mais'
  },
  bindBank: {
    title: 'Vincular cartão bancário',
    cardTitle: 'Informações bancárias',
    cardSubtitle: 'Selecione seu banco e insira os detalhes da conta',
    bankName: 'Banco',
    bankNamePlaceholder: 'Digite o nome do banco',
    cardNumber: 'Número do cartão',
    cardNumberPlaceholder: 'Digite o número do cartão',
    realName: 'Nome real',
    realNamePlaceholder: 'Digite o nome real',
    withdrawPassword: 'Senha de saque',
    withdrawPasswordPlaceholder: 'Digite a senha de saque',
    securityNotice: 'Aviso de segurança',
    securityText1: '• Suas informações bancárias estão criptografadas e armazenadas com segurança',
    securityText2: '• Apenas você pode visualizar e modificar esta informação',
    securityText3: '• Certifique-se de que todas as informações estejam corretas',
    buttonText: 'Salvar informações',
    buttonSubtitle: 'Vincular conta bancária',
    errorBankName: 'Digite o nome do banco',
    errorCardNumber: 'Digite o número do cartão',
    errorRealName: 'Digite o nome real',
    errorWithdrawPassword: 'Digite a senha de saque'
  }
}
